import styled from "@emotion/styled";

export const Container = styled.div<{ isShow: boolean }>`
  display: ${(props) => (props.isShow ? "flex" : "none")};
  flex-direction: column;
  gap: 24px;
  margin-top: 20px;
`;
